import { ErrorCode } from "react-dropzone";

const MAX_SIZE_MB = 100;

export const ERROR_MESSAGES = {
  [ErrorCode.FileInvalidType]: "Media format not supported",
  [ErrorCode.FileTooLarge]: `Exceeds maximum size (${MAX_SIZE_MB} MB)`,
};
